import {FC, createContext, useState, useContext, useEffect} from "react";
import { FooterProps, FooterProviderType } from "./types";
import {AuthContext} from "../authContext";

export const FooterContext = createContext<FooterProps>({
  isAccordianShown: false,
  changeAccordianVisibility: () =>{}
 });

const FooterProvider: FC<FooterProviderType> = ({ children }): JSX.Element => {

  const [isAccordianShown,setAccordianVisibility] = useState<boolean>(false);
  // const {isUserAuthorized} = useContext(AuthContext)
  //   useEffect(() => {
  //       if (isUserAuthorized ) setAccordianVisibility(false)
  //       else setAccordianVisibility(true)
  //   }, [isUserAuthorized]);
  
  const changeAccordianVisibility = () => {
    setAccordianVisibility((isAccordianShown) => !isAccordianShown);
  };

  return (
    <FooterContext.Provider
      value={{
        isAccordianShown,
        changeAccordianVisibility
      }}
    >
      {children}
    </FooterContext.Provider>
  );
};

export default FooterProvider;
